<div *ngIf="topic" class="topic-container"
     (contextmenu)="editPopover($event)"
     [style.--topic-color]="topic.color">
  {{topic.name}}
</div>
